export const FIELD_IS_REQUIRED = "Field is required";
export const INVALID_SELECTION = "Invalid selection";
export const START_TIME_SHOULD_BE_LESS_THAN_END_TIME = "Start time should be less than end time";
export const END_TIME_SHOULD_BE_GREATER_THAN_START_TIME = "End time should be greater than start time";
export const INVALID_IMAGE_URL_MESSAGE = "Invalid image URL";
export const MANUAL_VIDEO_REQUEST_MAX_DURATION_EXCEEDED =
    "The maximum duration for a manual video request is 30 minutes. Please adjust your selection.";
export const WARNING_DATE_FILTERING_DISABLED_BY_APPLIED_PRE_FILTER =
    "Date filtering is disabled by the current pre-filter. Please remove the pre-filter to enable date selection.";
export const UNABLE_TO_PERFORM_VIDEO_REQUEST = "Unable to perform video request:";
export const LOCATION_IS_NOT_AVAILABLE = "Location is not available";
export const DEVICES_ARE_NOT_AVAILABLE = "Devices are not available";
export const DEVICE_IS_NOT_AVAILABLE_FOR_THIS_LOCATION = "Device is not available for this location";
export const CAMERA_IS_NOT_AVAILABLE_FOR_THIS_DEVICE = "Camera is not available for this device";
